module.exports = __webpack_public_path__ + "img/set.22cba652.png";